import * as config from '../../../../../sites/common_site_config.json';
const host = window.location.href.split(":")[1]
export const environment = {
  production: true,
  apiDomain:'',
  // sockectURl :`http:${host}:${config.socketio_port}`,
  sockectURL:'',
  appUrl : ''
};